import InputLabel from '@material-ui/core/InputLabel'
import styled, { css } from 'styled-components'
import media from 'styled-media-query'

export const Wrapper = styled.main`
  display: grid;
  flex-direction: column;
  padding: 16px;
  grid-gap: 16px 32px;
  grid-template-columns: repeat(2, 40%);
  grid-template-rows: repeat(2, 1fr);
  border-radius: 8px;
  ${({ theme }) => css`
    background-color: ${theme.colors.mainBg};
  `}

  ${media.lessThan('medium')`
    grid-gap: 16px 0;
    grid-template-columns: 1fr;
    grid-template-rows: auto;
  `}
`

export const Campos = styled.div`
  display: grid;
  grid-template-columns: 50% 24%;
  justify-content: flex-start;

  ${media.lessThan('medium')`
    grid-template-columns: 60% 40%;
  `}
`

export const CamposAreaLote = styled(Campos)`
  ${media.lessThan('medium')`
    grid-row-start:3
  `}
`

export const Label = styled(InputLabel)`
  font-family: 'IBMPlexSans-Bold';
  ${({ theme }) => css`
    font-size: ${theme.font.sizes.small};
    font-weight: 600;
  `};
`
export const Valor = styled(Label)`
  text-align: end;
`
